import dayjs from "dayjs";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import { z } from "zod";

export const BaseSchema = z.object({
  firmId: z.string(),
  pk: z.string(),
  sk: z.string(),
  dateCreated: z.string(),
  dateModified: z.string(),
});

export const EmailSchema = z
  .string()
  .trim()
  .email({ message: "Invalid email format" })
  .min(6, { message: "Email is too short" })
  .max(80, { message: "Email is too long" });

export const PhoneNumberSchema = z
  .string()
  .trim()
  .refine(
    (value) => {
      return value && isPossiblePhoneNumber(value);
    },
    { message: "Invalid phone number" },
  );

export const StreetAddressSchema = z
  .string()
  .trim()
  .min(1, { message: "Address is required" })
  .max(200, { message: "Address is too long" });

export const CitySchema = z
  .string()
  .trim()
  .min(1, { message: "City is required" })
  .max(100, {
    message: "City is too long",
  });

export const CountrySchema = z
  .string()
  .trim()
  .min(1, { message: "Country is required" })
  .max(100, {
    message: "Country is too long",
  });

export const StateSchema = z
  .string()
  .trim()
  .min(1, { message: "State is required" })
  .max(100, {
    message: "State is too long",
  });

export const ZipCodeSchema = z
  .string()
  .min(5, { message: "Zip code is too short" })
  .max(20, {
    message: "Zip code is too long",
  });

export const PasswordSchema = z
  .string()
  .min(8, { message: "Password is too short" })
  .regex(
    new RegExp(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
    ),
    {
      message:
        "Password must contain an uppercase letter, lowercase letter, a number, and a special character",
    },
  );

export const BirthdateSchema = z
  .string()
  .refine(
    (value) => {
      const date = dayjs(value);
      return date.isAfter("1899-12-31", "month");
    },
    { message: "Year must be after 1900" },
  )
  .refine(
    (value) => {
      const date = dayjs(value);
      return date.isBefore(dayjs().add(1, "day"), "day");
    },
    { message: "Date cannot be in the future" },
  );
